import { Divider } from '@/components/common/Divider';
import { TopNavigationBar } from '@/components/common/TopNavigationBar';
import SideLayout from '@/layouts/SideLayout';
import React, { useState } from 'react';

const OperationAnalysisPage = () => {
  const [selectedNavigationIndex, setSelectedNavigationIndex] = useState(0);
  const topNavigationBarMenus = [
    {
      text: 'management.navigation.windPowerDailyReport',
      context: 'operation',
    },
    {
      text: 'management.navigation.solarPowerDailyReport',
      context: 'operation',
    },
  ];
  return (
    <SideLayout>
      <div>
        <TopNavigationBar
          selectedIndex={selectedNavigationIndex}
          menus={topNavigationBarMenus}
          setNavigationIndex={setSelectedNavigationIndex}
        />
        <Divider className="bg-light-4" />
      </div>
      {selectedNavigationIndex === 0 ? (
        <iframe
          style={{ width: '100%', height: '100vh', border: 'none' }}
          src="https://ap-northeast-2.quicksight.aws.amazon.com/sn/embed/share/accounts/223771790718/dashboards/74604724-cf10-4078-923c-393ba5e16e0d?directory_alias=gswp"
        ></iframe>
      ) : (
        <iframe
          style={{ width: '100%', height: '100vh', border: 'none' }}
          src="https://ap-northeast-2.quicksight.aws.amazon.com/sn/embed/share/accounts/223771790718/dashboards/22b8424b-c7ef-4161-aae9-f6b10a06637f?directory_alias=gswp"
        ></iframe>
      )}
    </SideLayout>
  );
};

export default OperationAnalysisPage;
